<template>
    <v-card v-if="isExist">
        <v-card-title class="headline">Finalized?</v-card-title>
        <v-card-text>do you want to finalize!</v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogueClose">{{$t('no')}}</v-btn>
            <v-btn color="green darken-1" text @click="deleteData">{{$t('yes')}}</v-btn>
        </v-card-actions>
    </v-card>
    <v-card v-else>
        <v-card-title class="headline">REPORT NOT APPROVED !</v-card-title>
        <v-card-text>कृपया, Original Report लाई Approve गरि मात्र Finalize गर्नुहोला |</v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogueClose">{{$t('close')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";

    export default {
        name: "finalized",
        props: ["finalizedFormData"],
        /*watch: {
          created: {
            handler: function(val) {
              console.log({val});
            },
            deep: true
          }
        },*/
        data() {
            return {
                isExist: false,
                servicesData: {
                    data: {},
                    message: "",
                    color: ""
                }
            };
        },
        methods: {
            dialogueClose() {
                this.servicesData.message = 'Cancelled'
                this.servicesData.color = 'red'
                this.$emit("formResponse", this.servicesData);
            },
            deleteData() {


                axios.post("ReportSettings/IsFinalFinalized", this.finalizedFormData.item, {})
                    .then((response) => {
                        this.servicesData.data = response.data
                        this.servicesData.message = "Data Finalized Succcessfully"
                        this.servicesData.color = "success"
                        this.dialogueClose()
                        this.$emit("formResponse", this.servicesData);
                    })
                    .catch(response => {
                        this.servicesData.data = response.data
                        this.servicesData.message = "Could not Finalized Please Contact Admin"
                        this.servicesData.color = "error"
                        this.dialogueClose()

                    });
            },
            checkStatus() {
                let reportLogID = this.finalizedFormData.item.ReportLogID;
                let reportID = this.finalizedFormData.item.ReportID;
                axios.get("ReportSettings/GetFinalActualReportExisted/" + reportLogID + "/" + reportID).then(response => {
                    this.isExist = response.data.existed
                })
            }
        }
    };
</script>

<style scoped>
</style>